// extracted by mini-css-extract-plugin
export default {"SwipeableViews":"_3SjMZiCgacBt_-mdhFlw5i"};